<script>
/**
 * Presentational assign control (Lovable AssignmentControl → Vue Options API).
 * Emits user id (or name when options lack id) for the bridge to persist.
 */
export default {
    name: 'AssignmentControl',
    props: {
        assignedUserId: { type: [Number, String], default: null },
        assignees: {
            type: Array,
            default: () => [],
            // [{ id, name }] or string names (demo-compatible)
        },
        currentUserId: { type: [Number, String], default: null },
        currentUserLabel: { type: String, default: 'Prendi in carico' },
        placeholder: { type: String, default: 'Assegna a...' },
        ariaLabel: { type: String, default: 'Assegna ticket' },
    },
    emits: ['assign'],
    computed: {
        options() {
            return (this.assignees || []).map((member) => {
                if (member && typeof member === 'object') {
                    return {
                        id: member.id ?? member.value ?? member.name,
                        name: member.name ?? member.label ?? String(member.id),
                    };
                }
                return { id: member, name: String(member) };
            });
        },
        selectValue() {
            if (this.assignedUserId === null || this.assignedUserId === undefined || this.assignedUserId === '') {
                return '';
            }
            return String(this.assignedUserId);
        },
        canAssignToMe() {
            return this.currentUserId !== null && this.currentUserId !== undefined && this.currentUserId !== '';
        },
    },
    methods: {
        onSelect(event) {
            const value = event.target.value;
            if (value === '') {
                return;
            }
            this.$emit('assign', value);
        },
        assignToMe() {
            if (!this.canAssignToMe) {
                return;
            }
            this.$emit('assign', this.currentUserId);
        },
    },
};
</script>

<template>
    <div class="tickets-index-assign">
        <select
            :value="selectValue"
            :aria-label="ariaLabel"
            @change="onSelect"
        >
            <option value="" disabled>{{ placeholder }}</option>
            <option
                v-for="member in options"
                :key="String(member.id)"
                :value="String(member.id)"
            >
                {{ member.name }}
            </option>
        </select>
        <button
            type="button"
            class="tickets-index-btn tickets-index-assign__me"
            :disabled="!canAssignToMe"
            :title="currentUserLabel"
            :aria-label="currentUserLabel"
            @click="assignToMe"
        >
            <i class="fa fa-user-plus" aria-hidden="true"></i>
            <span>{{ currentUserLabel }}</span>
        </button>
    </div>
</template>
